import { Location } from "@reach/router";
import { FunctionComponent, useEffect, useState } from "react";
import getRoutes from "./routes";
import AppLayout from "./components/layout/Layout";
import { getUsersAndPermissions } from "./utils/helpers/data/userAndPermissions";
import { User } from "./utils/helpers/types";
import UserContext from "./context/user-context";

const tempUser: User = {
  username: "johnson.ubaezuonu",
  email: "jaycodist@gmail.com",
  domainCode: "ISW",
  firstname: "Johnson",
  lastname: "Ubaezuonu",
  userType: "ISW_ADMIN"
};

const App: FunctionComponent = () => {
  const [user, setUser] = useState<User | null>(tempUser);
  const [waitingMessage, setWaitingMessage] = useState("Loading. . .");

  useEffect(() => {
    const fetchUserAndPermissions = async () => {
      const response = await getUsersAndPermissions();
      if (response.error) {
        setWaitingMessage(
          "Unable to load application. Please contact your administrator"
        );
        return;
      }
      setUser(response.data);
    };

    fetchUserAndPermissions();
  }, []);

  return user ? (
    <UserContext.Provider value={user}>
      <Location>
        {({ location }) => (
          <AppLayout location={location}>{getRoutes(user)}</AppLayout>
        )}
      </Location>
    </UserContext.Provider>
  ) : (
    <div>{waitingMessage}</div>
  );
};

export default App;
